import { Operations } from '../operation-action-map'

import * as fromActions from './signal-r.actions'

export type State = typeof initialState

export const initialState = {
  FeedbackNotificationCount: null as number | null,
  GoalNotificationCount: null as number | null,
  ReviewNotificationCount: null as number | null,
  MyTeamNotificationCount: null as number | null,
  TeamGoalsNotificationCount: null as number | null,
  TeamReviewNotificationCount: null as number | null,
}

export const reducer = (state = initialState, action: fromActions.default): State => {
  switch (action.type) {
    case fromActions.SIGNALR_ALL_BADGES_INIT_SUCCESS: {
      const { payload: data } = action

      /** TODO: change BE implementation */
      const newWholeState: State = {
        FeedbackNotificationCount: data.feedback,
        GoalNotificationCount: data.goal,
        ReviewNotificationCount: data.review,
        MyTeamNotificationCount: data.myTeam,
        TeamGoalsNotificationCount: data.teamGoals,
        TeamReviewNotificationCount: data.teamReview,
      }

      return newWholeState
    }

    case fromActions.SIGNALR_NOTIFICATION_GOAL_COUNT: {
      const { value } = action.payload

      return {
        ...state,
        GoalNotificationCount: value,
      }
    }

    case fromActions.SIGNALR_NOTIFICATION_TEAM_GOAL_COUNT: {
      const { value } = action.payload

      return {
        ...state,
        TeamGoalsNotificationCount: value,
      }
    }

    case fromActions.SIGNALR_NOTIFICATION_FEEDBACK_COUNT: {
      const { value } = action.payload

      return {
        ...state,
        FeedbackNotificationCount: value,
      }
    }

    case fromActions.SIGNALR_NOTIFICATION_REVIEW_COUNT: {
      const { value } = action.payload

      return {
        ...state,
        ReviewNotificationCount: value,
      }
    }

    case fromActions.SIGNALR_NOTIFICATION_TEAM_REVIEW_COUNT: {
      const { value } = action.payload

      return {
        ...state,
        TeamReviewNotificationCount: value,
      }
    }

    case fromActions.SIGNALR_GOAL_BADGE_INIT_SUCCESS: {
      return {
        ...state,
        GoalNotificationCount: action.payload,
      }
    }

    case fromActions.SIGNALR_FEEDBACK_BADGE_INIT_SUCCESS: {
      return {
        ...state,
        FeedbackNotificationCount: action.payload,
      }
    }

    case fromActions.SIGNALR_MY_TEAM_BADGE_INIT_SUCCESS: {
      return {
        ...state,
        MyTeamNotificationCount: action.payload,
      }
    }

    case fromActions.SIGNALR_REVIEW_BADGE_INIT_SUCCESS: {
      return {
        ...state,
        ReviewNotificationCount: action.payload,
      }
    }

    case fromActions.SIGNALR_TEAM_GOAL_BADGE_INIT_SUCCESS: {
      return {
        ...state,
        TeamGoalsNotificationCount: action.payload,
      }
    }

    case fromActions.SIGNALR_TEAM_REVIEW_BADGE_INIT_SUCCESS: {
      return {
        ...state,
        TeamReviewNotificationCount: action.payload,
      }
    }

    default:
      return state
  }
}

export const getSignalRData = (state: State, operation: Operations) => state[operation]
export const getWholeData = (state: State) => state



// WEBPACK FOOTER //
// ./src/modules/signal-r/store/signal-r.reducer.ts